import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Checkbox } from '@mui/material';
import { BsThreeDots } from 'react-icons/bs';
import { toast } from 'react-toastify';

import useDebounce from '../../CustomHooks/useDebounce';
import { MSG_ERROR } from '../../utils/contants';
import { apiHeader, BaseURL } from '../../config/apiUrl';
import { Get, Delete } from '../../Axios/AxiosFunctions';
import { Button } from '../../Component/Button/Button';
import TableSkeleton from '../../Component/TableSkeleton';
import NoData from '../../Component/NoData/NoData';
import PoperComponent from '../../Component/PopperComponent';
import SearchInput from '../../Component/SearchInput';
import AreYouSureModal from '../../modals/AreYouSureModal';
import classes from './AutomatedEmails.module.css';

const recordsLimit = 40;

const AutomatedSmsList = () => {
  const navigate = useNavigate();

  const { user, access_token: accessToken, company_id: companyId } = useSelector(
    (state) => state?.authReducer,
  );

  const superAdminEmail = process.env.REACT_APP_SUPER_ADMIN_EMAIL;
  const baseApiUrl = BaseURL(`automated-sms-template`);

  const [isFetching, setIsFetching] = useState(true);
  const [page] = useState(1);
  const [data, setData] = useState(null);
  const [openPopper, setOpenPopper] = useState(false);
  const anchorRef = useRef(null);
  const [indexMap, setIndexMap] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [openDeleteConfirmation, setOpenDeleteConfirmation] = useState('');
  const [search, setSearch] = useState('');
  const debouncedSearchTerm = useDebounce(search, 500);

  const getAll = async () => {
    if (accessToken && accessToken?.length > 0) {
      const url = `${baseApiUrl}?search=${search}&page=${page}&limit=${recordsLimit}`;
      const response = await Get(url, accessToken, companyId);

      if (response?.status === 200) {
        setData(response?.data);
      }

      setIsFetching(false);
    }
  };

  const handleActionClick = (flag) => {
    if (flag == 'Delete') {
      setOpenDeleteConfirmation(true);
    } else if (flag == 'Edit') {
      navigate(`/edit-automated-sms/${selectedItem?._id}`);
    }
  };

  const handleDelete = async () => {
    const response = await Delete(
      `${baseApiUrl}/${selectedItem?._id}`,
      apiHeader(accessToken),
    );

    if (response?.status === 200) {
      toast.success('Deleted successfully.');
      getAll();
      setSelectedItem(null);
      setOpenDeleteConfirmation(false);
    } else {
      toast.error(response.data || MSG_ERROR);
    }
  };

  const handleToggle = () => {
    setOpenPopper((prev) => !prev);
  };

  useEffect(() => {
    getAll();
  }, [accessToken, debouncedSearchTerm]);

  return (
    <>
      <div
        className={[classes.headerContainer]}
        style={{ justifyContent: 'flex-end' }}
      >
        <div className={[classes.inputDiv]}>
          <SearchInput
            setter={setSearch}
            value={search}
            placeholder={'Search'}
          />

          {user?.email === superAdminEmail && (
            <Button
              label="Add SMS"
              className={classes.addProjectBtn}
              onClick={() => {
                navigate('/add-automated-sms');
              }}
            />
          )}
        </div>
      </div>

      <div className="table100 ver1 m-b-110">
        <div className="table100-head">
          <table style={{ tableLayout: 'fixed', width: '100%' }}>
            <thead>
              <tr className="row100 head">
                <th
                  className="cell100 column1"
                  style={{ width: '5%', textAlign: 'start' }}
                >
                  S.No
                </th>
                <th
                  className="cell100 column1"
                  style={{ width: '20%', textAlign: 'start' }}
                >
                  Trigger
                </th>
                <th
                  className="cell100 column3"
                  style={{ width: '15%', textAlign: 'start' }}
                >
                  To
                </th>
                <th
                  className="cell100 column4"
                  style={{ width: '15%', textAlign: 'start' }}
                >
                  CC
                </th>
                <th
                  className="cell100 column5"
                  style={{ width: '30%', textAlign: 'start' }}
                >
                  Message
                </th>
                <th
                  className="cell100 column7"
                  style={{ width: '10%', textAlign: 'center' }}
                >
                  Active
                </th>
                {user?.email === superAdminEmail && (
                  <th
                    className="cell100 column10"
                    style={{ width: '5%', textAlign: 'center' }}
                  >
                    Action
                  </th>
                )}
              </tr>
            </thead>
          </table>
        </div>
        {isFetching ? (
          <TableSkeleton rowsCount={recordsLimit} colsCount={7} />
        ) : (
          <div className="table100-body js-pscroll ps ps--active-y">
            <table style={{ tableLayout: 'fixed', width: '100%' }}>
              <tbody>
                {data?.result?.length > 0 ? (
                  data?.result?.map((item, index) => (
                    <tr
                      key={item?._id}
                      className="row100 body"
                      style={{
                        backgroundColor:
                          selectedItem?._id == item?._id && '#E5F5FF',
                      }}
                    >
                      <td
                        className="cell100 column1"
                        style={{ width: '5%', textAlign: 'start' }}
                      >
                        {page == 1
                          ? index + 1
                          : recordsLimit * (page - 1) + index + 1}
                      </td>
                      <td
                        className="cell100 column1"
                        style={{ width: '20%', textAlign: 'start' }}
                      >
                        {item?.trigger}
                      </td>
                      <td
                        className="cell100 column4"
                        style={{
                          width: '15%',
                          textAlign: 'start',
                          maxWidth: '15%',
                          textOverflow: 'ellipsis',
                          overflow: 'hidden',
                        }}
                      >
                        {item?.to}
                      </td>
                      <td
                        className="cell100 column5"
                        style={{
                          width: '15%',
                          textAlign: 'start',
                          maxWidth: '15%',
                          textOverflow: 'ellipsis',
                          overflow: 'hidden',
                        }}
                      >
                        {item?.cc}
                      </td>
                      <td
                        className="cell100 column6"
                        style={{
                          width: '30%',
                          textAlign: 'start',
                          maxWidth: '30%',
                          textOverflow: 'ellipsis',
                          overflow: 'hidden',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        {item?.message}
                      </td>
                      <td
                        className="cell100 column8"
                        style={{ width: '10%', textAlign: 'center' }}
                      >
                        <div style={{ position: 'relative' }}>
                          <Checkbox checked={item?.isEnabled} disabled={true} />
                        </div>
                      </td>

                      {user?.email === superAdminEmail && (
                        <td
                          className="cell100 column11"
                          style={{ width: '5%', textAlign: 'center' }}
                        >
                          <div
                            ref={index == indexMap ? anchorRef : null}
                            id="composition-button"
                            aria-controls={
                              openPopper ? 'composition-menu' : undefined
                            }
                            aria-expanded={openPopper ? 'true' : undefined}
                            aria-haspopup="true"
                            onClick={() => {
                              setSelectedItem(item);
                              setIndexMap(index);
                              setTimeout(() => {
                                handleToggle();
                              }, 100);
                            }}
                          >
                            <BsThreeDots
                              size={30}
                              className={[classes.threeDots]}
                            />
                          </div>
                        </td>
                      )}
                    </tr>
                  ))
                ) : (
                  <NoData text={'No Automated SMS Found'} />
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>

      <PoperComponent
        handleClick={handleActionClick}
        open={openPopper}
        setOpen={setOpenPopper}
        anchorRef={anchorRef}
        data={['Edit', 'Delete']}
      />

      <AreYouSureModal
        show={openDeleteConfirmation}
        setShow={setOpenDeleteConfirmation}
        subTitle={`Are you sure you want delete this SMS`}
        isApiCall={false}
        onClick={() => handleDelete()}
      />
    </>
  );
};

export default AutomatedSmsList;
